document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll("[data-init-carousel].swiper-container");
  carousels.forEach((carousel) => {
    var slideCount = carousel.querySelectorAll('.swiper-slide').length;

    function getSlidesOffsetAfter() {
      var isMobile = window.innerWidth < 768;
      return (isMobile || slideCount > 5) ? 100 : 0;
    }

    var swiper = new Swiper(carousel, {
      direction: "horizontal",
      slidesPerView: 5,
      speed: 1000,
      spaceBetween: 18,
      slidesOffsetAfter: getSlidesOffsetAfter(),
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        375: {
          slidesPerView: 1.75,
        },
        425: {
          slidesPerView: (carousel.getAttribute("data-mobile-slides-per-view")) ? carousel.getAttribute("data-mobile-slides-per-view")  : 2.75
        },
        768: {
          slidesPerView: (carousel.getAttribute("data-tablet-slides-per-view")) ? carousel.getAttribute("data-tablet-slides-per-view") : 3.5,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: (carousel.getAttribute("data-desktop-slides-per-view")) ? carousel.getAttribute("data-desktop-slides-per-view") : 5,
          spaceBetween: 18,
        },
      },
  
      // Navigation arrows
      navigation: {
        nextEl: `.swiper-button-next-${carousel.getAttribute("data-id")}`,
        prevEl: `.swiper-button-prev-${carousel.getAttribute("data-id")}`,
      },
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        swiper.params.slidesOffsetAfter = getSlidesOffsetAfter();
        swiper.update();
      }, 150);
    });
  });
});

